import React from "react";
import "./BriefArticle.css";
import TEXT from "../../../utils/text/misc.json";

/**
 *
 * @param {string} title
 * @param {string} description
 * @param {string} href
 *
 * @returns Article Brief Component
 */

export default function BriefArticle({ title, description, href, language, target = "_blank"}) {
  return (
    <div className="brief-box">
      <h2 className="brief-title">{title}</h2>
      <p className="brief-description">{description}</p>
      <a
        className="brief-read-more"
        href={href}
        target={target}
        rel="noreferrer"
      >
        {TEXT["seeMore"][language]}
      </a>
    </div>
  );
}
